import React from 'react'

export default function SuccessIcon() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="20" fill="#3C4FB9" />
            <path d="M20.0052 11.666C15.4052 11.666 11.6719 15.3993 11.6719 19.9993C11.6719 24.5993 15.4052 28.3327 20.0052 28.3327C24.6052 28.3327 28.3385 24.5993 28.3385 19.9993C28.3385 15.3993 24.6052 11.666 20.0052 11.666ZM18.3385 24.166L14.1719 19.9993L15.3469 18.8243L18.3385 21.8077L24.6635 15.4827L25.8385 16.666L18.3385 24.166Z" fill="white" />
        </svg>
    )

}
